module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('hgroup', [_c('h1', {
    staticClass: "FMH"
  }, [_c('a', {
    attrs: {
      "id": "PageBreak-vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "PageBreak-vii"
    }
  })]), _c('a', {
    attrs: {
      "id": "PageBreak-vii"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "PageBreak-vii"
    }
  }), _c('li', {
    staticClass: "CFMH",
    attrs: {
      "id": "c_intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "PageBreak-vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro"
    }
  }, [_vm._v("Introduction: The Jewish-Muslim Question in Modern France")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter_1#ch1"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1.")]), _vm._v(" Jewish, Muslim, and Possibly French")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("2.")]), _vm._v(" Pushing the Boundaries of Mediterranean France")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("3.")]), _vm._v(" Jews as Muslims and Muslims as Jews")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("4.")]), _vm._v(" Expanding the Republic or Ending the Empire?")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("5.")]), _vm._v(" A Time of Choosing")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("6.")]), _vm._v(" Higher Fences, Better Neighbors?")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT",
    attrs: {
      "id": "c_ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("7.")]), _vm._v(" Jews as Jews and Muslims as Muslims")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT-1",
    attrs: {
      "id": "c_conclu"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#conclu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Jews and Muslims Always and Forever?")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_note"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH",
    attrs: {
      "id": "c_index"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0